import { Env, MultiClient } from "config"
import { CLIENT } from "config/init"
import translate_default from "translates/translation.json"
import translate_entel from "overrides/theme/entel/base/translates/translation.json"
import translate_entelperu from "overrides/theme/entelperu/base/translates/translation.json"

const getTranslateConfig = () => {
  let [_client] = MultiClient.get_user_env(null, Env.clients, Env.env, Env.defaults)

  const clients: { [k: string]: any } = {
    [CLIENT.ENTEL]: translate_entel,
    [CLIENT.ENTEL_PERU]: translate_entelperu,
    default: translate_default,
  }

  return clients[_client] || clients.default
}

export default getTranslateConfig
